// ⚠️⚠️⚠️⚠️ AUTO GENERATED FILE ⚠️⚠️⚠️⚠️ DO NOT EDIT ⚠️⚠️⚠️⚠️
/* eslint-disable */
// @ts-nocheck
import type * as Types from '@/graphql/schema';

import useSubscription from '@/client/hooks/useSubscription';
import gql from '@/graphql/gql';
export type KycNotificationAddedSubscriptionVariables = Types.Exact<{
  input: Types.CasinoNotificationKycNotificationAddedSubscriptionInput;
}>;


export type KycNotificationAddedSubscription = { __typename?: 'Subscription', casinoNotificationKycNotificationAdded?: { __typename?: 'CasinoNotificationKycNotificationAddedSubscriptionPayload', clientSubscriptionId?: string, addedNotification?: { __typename?: 'CasinoNotificationKycNotificationEdge', node?: { __typename?: 'CasinoNotificationKycNotification', id: string, userId?: string, isRead?: boolean, name?: string, eventTime?: number, createTime?: number, verificationProcess?: { __typename?: 'CasinoNotificationKycNotificationVerificationProcess', status?: Types.KycNotificationVerificationProcessStatus, verificationType?: string, declineReasons?: Array<string>, level?: { __typename?: 'CasinoNotificationKycNotificationVerificationProcessLevel', name?: string, status?: Types.KycNotificationVerificationProcessLevelStatus } } } } } };

export type KycNotificationFragment = { __typename?: 'CasinoNotificationKycNotification', id: string, userId?: string, isRead?: boolean, name?: string, eventTime?: number, createTime?: number, verificationProcess?: { __typename?: 'CasinoNotificationKycNotificationVerificationProcess', status?: Types.KycNotificationVerificationProcessStatus, verificationType?: string, declineReasons?: Array<string>, level?: { __typename?: 'CasinoNotificationKycNotificationVerificationProcessLevel', name?: string, status?: Types.KycNotificationVerificationProcessLevelStatus } } };

export const KycNotificationFragmentDoc = gql`
    fragment KycNotificationFragment on CasinoNotificationKycNotification {
  id
  userId
  isRead
  name
  eventTime
  createTime
  verificationProcess {
    status
    verificationType
    declineReasons
    level {
      name
      status
    }
  }
}
    `;
export const KycNotificationAddedSubscriptionDocument = gql`
    subscription KycNotificationAddedSubscription($input: CasinoNotificationKycNotificationAddedSubscriptionInput!) {
  casinoNotificationKycNotificationAdded(input: $input) {
    addedNotification {
      node {
        id
        ...KycNotificationFragment
      }
    }
    clientSubscriptionId
  }
}
    ${KycNotificationFragmentDoc}`;

export const useKycNotificationAddedSubscription = (options: { variables?: KycNotificationAddedSubscriptionVariables, onData: (data: KycNotificationAddedSubscription) => void } ) => { 
  return useSubscription<KycNotificationAddedSubscription, KycNotificationAddedSubscriptionVariables>(KycNotificationAddedSubscriptionDocument, options);
}